<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="justify-center">
        <v-flex xs12 sm11 md10>
          <h3 class="text-center">Insurance Providers</h3>
          <v-card>
            <v-card-title class="py-1">
              <v-text-field label="Search" v-model="filterBy" prepend-icon="search" clearable></v-text-field>
              <v-spacer></v-spacer>
              <v-btn small text href="/insurance-providers/create" outlined @click.stop.prevent="goTo('/insurance-providers/create')">
                <v-icon left>mdi-plus</v-icon>Add New
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-data-table :headers="headers" :items="insurance_providers" :search="filterBy" dense>
                <template v-slot:[`item.status`]="{ item }">
                  <v-switch v-model="item.status" @click.stop.prevent="changeStatus(item)" dense></v-switch>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-btn small text icon @click="goTo('/insurance-providers/' + item.id + '/edit')" color="orange">
                    <v-icon>{{ icons.edit }}</v-icon>
                  </v-btn>
                  <v-btn small text icon @click="deleteProvider(item)" color="red">
                    <v-icon>{{ icons.delete }}</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
            <v-card-actions>
              <p class="text-muted">Only active providers will be shown to clients. <br> If all providers are inactive, the insurance payment feature will be disabled in totality.</p>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/MainLayout'

  export default {
    name: 'InsuranceProviders',
    layout,
    props: [
      'insurance_providers'
    ],
    components: {},
    metaInfo () {
      return {
        title: 'Insurance Providers',
        titleTemplate: '%s | ' + this.$title,
      }
    },
    data () {
      return {
        filterBy: '',
        headers: [
          {
            text: 'Name', value: 'name'
          },
          {
            text: 'Address', value: 'address'
          },
          {
            text: 'Phone', value: 'phone',
          },
          {
            text: 'Email', value: 'email'
          },
          {
            text: 'Link', value: 'link',
          },
          {
            text: 'Active status', value: 'status'
          },
          {
            text: '', value: 'actions', align: 'right'
          }
        ]
      }
    },
    methods: {
      deleteProvider (provider) {
        swal({
          title: provider.name,
          text: 'Delete Provider?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: 'red',
          confirmButtonText:'Delete',
          closeOnConfirm: false,
          showLoaderOnConfirm: true,
        },
        function () {
          this.$inertia.delete('/insurance-providers/' + provider.id, {
            onSuccess: () => {
              swal.close()
            },
            onFinish: () => {
              swal.close()
            },
            preserveScroll: true,
          })
        }.bind(this))
      },
      changeStatus (provider) {
        var status = provider.status ? '0' : '1'
        this.$inertia.put('/insurance-providers/' + provider.id + '/status', { status: 0 }, {
          onFinish: () => {
            swal.close()
          },
          preserveScroll: true,
          preserveState: true,
        })
      }
    },
  }
</script>

<style>
   /**/
</style>
